function writeCookie(name, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        // Set time to current time + days (in milliseconds: times 24 for hours, 60 for minutes, 60 for seconds, 1000 for milliseconds)
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEquals = name + "=";

    var cookieArray = document.cookie.split(';');
    // For each value in the cookie array
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        // Remove leading spaces
        while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
        // If name= matches, return value
        if (cookie.indexOf(nameEquals) == 0) return cookie.substring(nameEquals.length, cookie.length);
    }
    return null;
}
